/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';

	const changeTab = ()=> {
		if($('.js-donationFlowTab').length) {
			$('.js-donationFlowTab').on('click', function () {
				$(this).parents('.js-donationFlowTabWrap').find('.js-donationFlowTab').removeClass(a);
				$(this).addClass(a);
				$(this).parents('.js-donationFlowTabWrap').find('.js-donationFlowContents').removeClass(a);
				$(this).parents('.js-donationFlowTabWrap').find('.js-donationFlowContents').eq($(this).index()).addClass(a);
			})
		}
	}

	changeTab();


})(window.jQuery, window.FUNCTIONS);
